<template>
    <div>
        <v-card class="pa-5" elevation="0">
            <h2>대역폭 (Bandwidth)</h2>
            <div ref="liveBandwidthChart" style="width: 100%; height: 400px;"></div>
        </v-card>
    </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
    name: 'LiveBandwidth',
    data() {
        return {
            chartInstance: null,
        };
    },
    props: ['bandwidthData'],
    methods: {
        initChart() {
            const chartDom = this.$refs.liveBandwidthChart;
            if (chartDom) {
                if (this.chartInstance) {
                    this.chartInstance.dispose();
                }
                this.chartInstance = echarts.init(chartDom);
                this.updateChart();
            } else {
                console.error('Chart DOM not found');
            }
        },
        updateChart() {
            if (this.chartInstance && this.bandwidthData) {
                const data = this.bandwidthData.map(item => [item.Timestamp, item.Value]);
                const option = {
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: { type: 'cross' }
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'time',
                        splitLine: { show: false }
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            formatter: '{value} Mbps'
                        }
                    },
                    series: [{
                        name: 'Bandwidth',
                        type: 'line',
                        data: data,
                        smooth: true,
                        label: { show: false, position: 'top', fontSize: 10 }
                    }]
                };
                this.chartInstance.setOption(option, true);
            } else {
                console.error('bandwidth instance error');
            }
        },
    },
    watch: {
        bandwidthData(newData) {
            if (newData && newData.length > 0) {
                this.initChart();
            }
        },
    },
    beforeDestroy() {
        if (this.chartInstance) {
            this.chartInstance.dispose();
        }
    }
};

</script>

<style scoped>
.primary {
    color: #006cea;
}
</style>